module.exports = __webpack_public_path__ + "static/media/icon_order.70c3d2a0.png";